@if (data.editType == 'edit_sub') {
<div class="sub-builder-holder">
  <h2>Update a subscription for: {{data.customer.name}}</h2>

  <app-dynamic-form [injectedForm]="subForm" [model]="'Sub'" [hideRelationships]="true" [itemId]="subId"></app-dynamic-form>

</div>
}
@else {
<div class="sub-builder-holder">
  <h2>Edit Pricing or Service Details</h2>
  <app-create-subscription-dialog [stripeObj]="data.stripeBody" [customer]="data.customer" [editType]="data.editType"></app-create-subscription-dialog>
</div>
}

<!--
@switch (data.editType) {
@case ('edit_services_or_pricing') {
<div class="sub-builder-holder">
  <h2>Edit Pricing or Service Details</h2>
  <app-create-subscription-dialog [stripeObj]="data.stripeBody" [customer]="data.customer" [editType]="data.editType"></app-create-subscription-dialog>
</div>
}
@case ('edit_sub') {
<div class="sub-builder-holder">
  <h2>Update a subscription for: {{data.customer.name}}</h2>

  <app-dynamic-form [injectedForm]="subForm" [model]="'Sub'" [hideRelationships]="true" [itemId]="subId"></app-dynamic-form>

</div>
}
}
-->